import { campaignStatusActions, useSetCampaignStatus } from "../../hooks/useCampaignStatus";
import type { CampaignStatus } from "../../../../shared/types";

/** Activate a draft campaign, or pause / resume an active one, from the campaign header. */
export function CampaignStatusControl({ brandId, campaign }: {
  brandId: string;
  campaign: { id: string; status: CampaignStatus | string; updated_at?: string | null };
}) {
  const setStatus = useSetCampaignStatus(brandId, campaign.id);
  const actions = campaignStatusActions(campaign.status);
  if (!actions.length) return null;
  return (
    <div className="flex flex-wrap items-center gap-2">
      {actions.map(action => (
        <button key={action.to} type="button" disabled={setStatus.isPending}
          onClick={() => setStatus.mutate({ status: action.to, ...(campaign.updated_at ? { expected_updated_at: campaign.updated_at } : {}) })}
          className={action.primary
            ? "inline-flex min-h-11 items-center rounded-lg bg-brand-600 px-4 text-sm font-medium text-white hover:bg-brand-700 disabled:opacity-50"
            : "inline-flex min-h-11 items-center rounded-lg border border-slate-300 bg-white px-3 text-sm font-medium text-slate-700 hover:bg-slate-50 disabled:opacity-50"}>
          {setStatus.isPending && setStatus.variables?.status === action.to ? action.pendingLabel : action.label}
        </button>
      ))}
      {setStatus.isError && <p role="alert" className="basis-full text-sm text-amber-900">
        {setStatus.error instanceof Error ? setStatus.error.message : "The campaign status could not be changed."} Reload the page and try again.
      </p>}
    </div>
  );
}
